import React, { type ButtonHTMLAttributes, type FC } from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Icon } from '@mobi/component-library/Assets/Icon'

export const SetDepositLimitButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ onClick }) => (
  <ButtonStyled size='xs' color='secondary_grey' onClick={onClick}>
    <div>Set a Deposit Limit</div>
    <Icon name='DuocolorArrowNarrowRight' size='1.6rem' />
  </ButtonStyled>
)

const ButtonStyled = styled(Button)({
  div: {
    marginRight: spacing.smx1,
  },
})
